unit DashboardItemLayout;

{
  Layout presets for dashboard widgets.
  Factory maps DashboardItemType strings to these flags; TDashboardItemWidget
  reads them instead of six near-duplicate subclasses.
}

interface

type
  TDashboardDisplayMode = (
    dmTableOnly,
    dmChartWithSummary,
    dmChartWithDrillDownCombo,
    dmLikeForLike,
    dmChartHideSummary
  );

  TDashboardDrillDownMode = (
    ddmNone,
    ddmAlways,
    ddmTradingPatternTitle
  );

  TDashboardItemLayout = record
    ItemType: string;
    DisplayMode: TDashboardDisplayMode;
    ChartHeight: Integer;
    SummaryRowCount: Integer;
    SummaryIterationCount: Integer;
    DrillDownMode: TDashboardDrillDownMode;
    RunSummarySQLOnComboChange: Boolean;
    CreateSummaryTableOnInit: Boolean;
    class function ForType(const ADashboardItemType: string): TDashboardItemLayout; static;
    class function IsKnownType(const ADashboardItemType: string): Boolean; static;
  end;

implementation

uses
  System.SysUtils;

class function TDashboardItemLayout.IsKnownType(const ADashboardItemType: string): Boolean;
begin
  Result :=
    SameText(ADashboardItemType, 'SQLSummaryTop5') or
    SameText(ADashboardItemType, 'SQLTable') or
    SameText(ADashboardItemType, 'SQLSummaryIncluded') or
    SameText(ADashboardItemType, 'SQLSingleSummary') or
    SameText(ADashboardItemType, 'SQLLikeForLike') or
    SameText(ADashboardItemType, 'SQLSingleLikeForLike');
end;

class function TDashboardItemLayout.ForType(const ADashboardItemType: string): TDashboardItemLayout;
begin
  Result.ItemType := ADashboardItemType;
  Result.DisplayMode := dmChartWithSummary;
  Result.ChartHeight := 540;
  Result.SummaryRowCount := 1;
  Result.SummaryIterationCount := 1;
  Result.DrillDownMode := ddmNone;
  Result.RunSummarySQLOnComboChange := False;
  Result.CreateSummaryTableOnInit := False;

  if SameText(ADashboardItemType, 'SQLTable') then
  begin
    Result.DisplayMode := dmTableOnly;
    Result.ChartHeight := 0;
    Result.SummaryRowCount := 10;
    Result.CreateSummaryTableOnInit := True;
  end
  else if SameText(ADashboardItemType, 'SQLSummaryTop5') then
  begin
    Result.DisplayMode := dmChartWithDrillDownCombo;
    Result.ChartHeight := 388;
    Result.SummaryRowCount := 5;
    Result.DrillDownMode := ddmAlways;
    Result.RunSummarySQLOnComboChange := True;
  end
  else if SameText(ADashboardItemType, 'SQLSingleSummary') then
  begin
    Result.DisplayMode := dmChartWithSummary;
    Result.ChartHeight := 540;
    Result.SummaryRowCount := 1;
    Result.DrillDownMode := ddmTradingPatternTitle;
  end
  else if SameText(ADashboardItemType, 'SQLSummaryIncluded') then
  begin
    Result.DisplayMode := dmChartWithSummary;
    Result.ChartHeight := 540;
    Result.SummaryRowCount := 1;
    Result.DrillDownMode := ddmTradingPatternTitle;
  end
  else if SameText(ADashboardItemType, 'SQLLikeForLike') then
  begin
    Result.DisplayMode := dmLikeForLike;
    Result.ChartHeight := 540;
    Result.SummaryRowCount := 2;
    Result.SummaryIterationCount := 2;
  end
  else if SameText(ADashboardItemType, 'SQLSingleLikeForLike') then
  begin
    Result.DisplayMode := dmChartHideSummary;
    Result.ChartHeight := 540;
    Result.SummaryRowCount := 2;
  end;
end;

end.
